import { BaseModel, attr, belongsTo } from "../../lib/itn-ui-kit/data";

export default class SettlementCheckModel extends BaseModel {
  static urlPath = "settlement_checks";

  @belongsTo("case") case;
  @belongsTo("user") createdBy;
  @belongsTo("user") updatedBy;
  @belongsTo("entity") paidBy;
  @belongsTo("entity") paidTo;
  @belongsTo("entity") intendedRecipient;
  @attr("string") createdAt;
  @attr("string") updatedAt;
  @attr("string") checkNumber;
  @attr("string") amount;
  @attr("string") totalAmount;
  @attr("string") checkDate;
  @attr("number") checkType;
  @attr("string") status;
  @attr("string") depositDate;
  @attr("string") cnbDepositDate;
  @attr("string") batchNumber;
  @attr("string") receivable;
  @attr("string") notes;
}
